/**
 * @generated SignedSource<<379d2103ecc96211c54b0861d38e0965>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widget"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "widget",
        "variableName": "widget"
      }
    ],
    "concreteType": "CreateOrUpdateWidgetMutation",
    "kind": "LinkedField",
    "name": "createWidget",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widgetId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateWidgetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateWidgetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e0fd34836041771e0f251431e013f41",
    "id": null,
    "metadata": {},
    "name": "CreateWidgetMutation",
    "operationKind": "mutation",
    "text": "mutation CreateWidgetMutation(\n  $widget: WidgetInput!\n) {\n  createWidget(widget: $widget) {\n    ok\n    error\n    widgetId\n  }\n}\n"
  }
};
})();

node.hash = "dab42fad10563211737e6430b7e37451";

export default node;
